import { State } from '../../core/reducers';
import { createSelector } from '@ngrx/store';
import { selectMonthlyCashFlowPerYearMonth, selectMonthlyCashFlowYearMonths } from './monthly-cashflow.reducer';
import { MonthlyCashFlow } from '../model/accounting.model';
import { Dictionary } from '@ngrx/entity';
import { selectYearMonthSpan } from './span.selector';


export const getMonthlyCashFlowState = (state: State) => state.monthlyCashFlowState;

export const selectMonthlyCashFlow = createSelector(
  getMonthlyCashFlowState,
  selectMonthlyCashFlowPerYearMonth
);

export const selectMonths = createSelector(
  getMonthlyCashFlowState,
  selectMonthlyCashFlowYearMonths
)

function getMonthlyCashFlow(yearMonths: string[], monthlyStates: Dictionary<MonthlyCashFlow>): MonthlyCashFlow[] {
  return yearMonths.reduce((cashFlows: MonthlyCashFlow[], yearMonth) => {
    const monthlyCashFlow = monthlyStates[yearMonth];
    if (monthlyCashFlow) {
      cashFlows.push(monthlyCashFlow);
    }
    return cashFlows;
  }, []);
}

export const selectMonthlyCashFlowWithinExistingSpan = createSelector(
  selectYearMonthSpan,
  selectMonthlyCashFlow,
  getMonthlyCashFlow
);